import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/29.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Czemu nazywają cię Samotnym Olędrem?"
            question=""
            audio={audio}
            answers={{

                ans1: "Dlaczego chodzi sam wieczorem nad rzeczką?",
                ans2: "Do widzenia!"
            }}
            links={{
                link1: PAGES.p46,
                link2: PAGES.p57,
            }}
            content={
                <div>
                    <ul>
                        <li>
                            Sam chodzę, to samotny. Moja rodzina przed kilkuset laty przyjechała tu z Niderlandów, to Olęder. Niejedno pole dziś można zasiać dzięki ich pracy, niejeden brzeg rzeki to oni wyregulowali…. Za ich upór i wiedzę wszyscy tu ich szanowali. Dzisiaj to tylko nazwy wiosek po nich zostały. Ale ja pamiętam, choć gęsi pasę tam, gdzie moim przodkom nie udało się odzyskać ziemi z wody, najpotężniejszego z żywiołów…
                        </li>
                    </ul>
                </div>
            }
        />

    );
}